import React from 'react';
import PropTypes from 'prop-types';
import { withGigCardContext } from '../gig_card_context';
import Badge from '../badge';
import Countdown from '../countdown';
import { isRisingTalent, isHireAgain, isBuyItAgain } from '../../utils/gigTypes';
import classNames from 'classnames';

const GigBadges = ({ cardType, type, gigId, limitedEdition, reliable, featured, qualityChoice, sellerName, availableNow, limitedEditionDeadline, pro, tooltipPositionClass, isProExperience }) => {
    const risingTalent = isRisingTalent(type);
    const hireAgain = isHireAgain(type);
    const buyItAgain = isBuyItAgain(type);

    const badges = [],
        badgeMatrix = [
            [<Badge key={`${gigId}_hire_again`} tooltipPositionClass={tooltipPositionClass} type="hire_again"/>, hireAgain],
            [<Badge key={`${gigId}_buy_it_again`} tooltipPositionClass={tooltipPositionClass} type="buy_it_again"/>, buyItAgain],
            [<Badge key={`${gigId}_badge_limited`} tooltipPositionClass={tooltipPositionClass} type="limited"/>, (limitedEdition && !isProExperience)],
            [<Badge key={`${gigId}_badge_talent`} tooltipPositionClass={tooltipPositionClass} type="talent"/>, risingTalent],
            [<Badge key={`${gigId}_badge_high_completion`} tooltipPositionClass={tooltipPositionClass} className="high-completion" type="high_completion"/>, reliable],
            [<Badge key={`${gigId}_badge_featured`} tooltipPositionClass={tooltipPositionClass} type="featured"/>, featured],
            [<Badge key={`${gigId}_badge_choice`} tooltipPositionClass={tooltipPositionClass} type="choice"/>, qualityChoice],
            [<Badge key={`${gigId}_badge_now`} tooltipPositionClass={tooltipPositionClass} type="now" seller={sellerName}/>, availableNow]
        ],
        badge = badgeMatrix.find(([badgeComponent, condition]) => condition); // eslint-disable-line no-unused-vars

    badge && badges.push(badge[0]);
    limitedEdition && badges.push(<Countdown key={`${gigId}_countdown`} className={classNames({'left-align': isProExperience && cardType !== 'list'})} deadline={limitedEditionDeadline}/>);
    pro && badges.push(<Badge key={`${gigId}_badge_pro`} tooltipPositionClass={tooltipPositionClass} type="pro" className={classNames({ 'pro': isProExperience, 'limited-edition': limitedEdition })}/>);

    return badges.length ? (<span className="gig-badge-container">{badges}</span>) : null;
};

GigBadges.propTypes = {
    featured: PropTypes.bool,
    limitedEdition: PropTypes.bool,
    limitedEditionDeadline: PropTypes.string,
    qualityChoice: PropTypes.bool,
    reliable: PropTypes.bool,
    availableNow: PropTypes.bool,
    type: PropTypes.string,
    sellerName: PropTypes.string,
    pro: PropTypes.bool,
    gigId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tooltipPositionClass: PropTypes.string,
    isProExperience: PropTypes.bool
};

const contextSelector = ({ cardType }) => ({ cardType });

export default withGigCardContext(contextSelector)(GigBadges);
export { GigBadges as UnwrappedGigBadges };



// WEBPACK FOOTER //
// ./src/shared/gig_badges/index.js